"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewPasswordSubmitsRequest = void 0;
var NewPasswordSubmitsRequest = /** @class */ (function () {
    function NewPasswordSubmitsRequest() {
    }
    return NewPasswordSubmitsRequest;
}());
exports.NewPasswordSubmitsRequest = NewPasswordSubmitsRequest;
;
//# sourceMappingURL=newPasswordSubmits.request.js.map